var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tooltip',{attrs:{"disabled":!_vm.showTooltip,"right":"","nudge-top":"55","nudge-left":"58","transition":"none","color":"#000"},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('div',_vm._g({staticClass:"player-actions__btn player-actions__play-pause__box",class:{
        'mx-2 ml-4': _vm.sm,
        'player-actions__play-pause--pause': _vm.isPlaying,
        'v-btn--disabled opacity-30': _vm.disabled,
        'ml-3 mx-1': _vm.xs,
      },on:{"click":function($event){return _vm.$emit('click')}}},on))]}}])},[_vm._v(" "),_c('span',{staticClass:"player-actions__text",class:{ 'mx-1': !_vm.isPlaying }},[_vm._v("\n    "+_vm._s(_vm.isPlaying ? "Pause" : "Play")+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }